module.exports = "/dog-racing/img/fast-betting-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/fast-betting-btn.png
// module id = 122
// module chunks = 7